<template>
    <div class="label-product-image">
        {{ label }}
    </div>
</template>

<script setup lang="ts">
defineProps<{ label: string }>()
</script>

<style scoped lang="scss">
.label-product-image {
    border-radius: 2px;
    padding: 4px 8px;
    background-color: var(--frosted-glass-background-grey);
    backdrop-filter: var(--frosted-glass-backdrop-filter);
    font-family: $effra-font-stack;
    font-size: 11px;
    letter-spacing: 0.05em;
    text-align: center;
    text-transform: uppercase;
    color: $slate;
    line-height: initial;
}
</style>
